(() => {
  const ROOT = "[data-moodz-pdp-upsells]";
  const TRACK = "[data-upsell-track]";
  const CARD = "[data-upsell-card]";
  const ADD = "[data-upsell-add]";
  const SELECT = "[data-upsell-variant-select]";
  const MSG = "[data-upsell-msg]";
  const PREV = "[data-upsell-prev]";
  const NEXT = "[data-upsell-next]";

  // ─────────────────────────────────────────────────────────────
  // Helpers UI
  // ─────────────────────────────────────────────────────────────
  function setLoading(btn, isLoading) {
    if (!btn) return;
    btn.disabled = !!isLoading;
    btn.classList.toggle("is-loading", !!isLoading);
  }

  function showMsg(card, text, type = "info") {
    const el = card?.querySelector(MSG);
    if (!el) return;
    el.textContent = text;
    el.dataset.type = type;
  }

  function getVariantIdFromCard(card) {
    const select = card.querySelector(SELECT);
    const fallback = card.getAttribute("data-upsell-default-variant-id");
    return String(select?.value || fallback || "").trim();
  }

  // ─────────────────────────────────────────────────────────────
  // Cart
  // ─────────────────────────────────────────────────────────────
  async function addToCartFormEncoded(variantId, quantity = 1) {
    const body = new URLSearchParams();
    body.set("id", String(variantId));
    body.set("quantity", String(quantity));

    const res = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body,
    });

    const text = await res.text();
    let data = {};
    try { data = text ? JSON.parse(text) : {}; } catch (e) {}

    if (!res.ok) {
      const message =
        data?.description ||
        data?.message ||
        (typeof data === "string" ? data : null) ||
        "Impossible d'ajouter au panier.";
      throw new Error(message);
    }
    return data;
  }

  async function refreshThemeCart(cartData) {
    if (typeof publish === "function" && window.PUB_SUB_EVENTS?.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "moodz-pdp-upsells",
        cartData: cartData || null,
      });
      return;
    }

    try {
      const freshCart = cartData || await fetch("/cart.js", {
        headers: { Accept: "application/json" }
      }).then(r => r.json());

      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer && typeof cartDrawer.renderContents === "function") {
        const sections = ["cart-drawer", "cart-icon-bubble"];
        const res = await fetch(`/cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [], sections, sections_url: window.location.pathname }),
        });
        if (res.ok) {
          const data = await res.json();
          cartDrawer.renderContents({ ...freshCart, sections: data.sections });
          return;
        }
      }
    } catch (e) {
      console.warn("[MoodzUpsells] Fallback renderContents échoué :", e);
    }

    try {
      const drawerRes = await fetch(window.Shopify?.routes?.root + "?sections=cart-drawer,cart-icon-bubble", {
        headers: { Accept: "application/json" }
      });
      if (!drawerRes.ok) throw new Error("sections fetch failed");
      const sections = await drawerRes.json();

      const cartDrawerEl = document.querySelector("#CartDrawer");
      if (cartDrawerEl && sections["cart-drawer"]) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections["cart-drawer"], "text/html");
        const newInner = doc.querySelector(".drawer__inner");
        const oldInner = cartDrawerEl.querySelector(".drawer__inner");
        if (oldInner && newInner) oldInner.innerHTML = newInner.innerHTML;
      }

      const bubbleEl = document.getElementById("cart-icon-bubble");
      if (bubbleEl && sections["cart-icon-bubble"]) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections["cart-icon-bubble"], "text/html");
        const newBubble = doc.querySelector(".shopify-section");
        if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
      }
    } catch (e) {
      console.warn("[MoodzUpsells] Re-render ciblé échoué :", e);
    }
  }

  function openCartDrawerIfExists() {
    const cartDrawerEl = document.querySelector("cart-drawer");
    if (cartDrawerEl && typeof cartDrawerEl.open === "function") {
      cartDrawerEl.open();
      return true;
    }
    if (typeof window.openCartDrawer === "function") {
      window.openCartDrawer();
      return true;
    }
    const candidates = [
      "#cart-icon-bubble",
      "[data-cart-drawer-open]",
      ".header__icon--cart",
      ".cart-drawer__toggle",
      'a[href="/cart"]',
    ];
    for (const sel of candidates) {
      const el = document.querySelector(sel);
      if (el) { el.click(); return true; }
    }
    return false;
  }

  // ─────────────────────────────────────────────────────────────
  // SLIDER — logique flèches uniquement, pas de wheel hijack
  // ─────────────────────────────────────────────────────────────
  function getCards(track) {
    return Array.from(track.querySelectorAll(CARD));
  }

  function getCardsPerView(track) {
    const cards = getCards(track);
    if (!cards.length) return 1;
    const trackW = track.getBoundingClientRect().width;
    const cardW = cards[0].getBoundingClientRect().width + 12; // 12 = gap
    return Math.max(1, Math.round(trackW / cardW));
  }

  function getCurrentIndex(track) {
    const cards = getCards(track);
    if (!cards.length) return 0;
    // L'index courant = la carte la plus proche du bord gauche du track
    const scrollLeft = track.scrollLeft;
    let bestIdx = 0, bestDist = Infinity;
    cards.forEach((card, i) => {
      const dist = Math.abs(card.offsetLeft - scrollLeft);
      if (dist < bestDist) { bestDist = dist; bestIdx = i; }
    });
    return bestIdx;
  }

  function goToIndex(track, idx) {
    const cards = getCards(track);
    if (!cards.length) return;
    const clamped = Math.max(0, Math.min(idx, cards.length - 1));
    track.scrollTo({ left: cards[clamped].offsetLeft, behavior: "smooth" });
  }

  function updateArrows(track, prev, next) {
    if (!prev || !next) return;
    const cards = getCards(track);
    const perView = getCardsPerView(track);
    const idx = getCurrentIndex(track);
    prev.disabled = idx === 0;
    next.disabled = idx >= cards.length - perView;
    // Visibilité
    prev.style.opacity = prev.disabled ? "0.3" : "1";
    next.style.opacity = next.disabled ? "0.3" : "1";
  }

  // ─────────────────────────────────────────────────────────────
  // BIND
  // ─────────────────────────────────────────────────────────────
  function bind(root) {
    if (!root || root.dataset.moodzBound === "true") return;
    root.dataset.moodzBound = "true";

    const track = root.querySelector(TRACK);
    const prev = root.querySelector(PREV);
    const next = root.querySelector(NEXT);

    // ---------- Add to cart ----------
    root.addEventListener("click", async (e) => {
      const btn = e.target.closest(ADD);
      if (!btn) return;

      const card = btn.closest(CARD);
      if (!card) return;
      e.preventDefault();

      const variantId = getVariantIdFromCard(card);
      if (!variantId) {
        showMsg(card, "Variante invalide (ID manquant).", "error");
        return;
      }

      const openDrawer = root.dataset.openCartDrawer === "true";
      const scrollToDrawer = root.dataset.scrollToDrawer === "true";

      try {
        setLoading(btn, true);
        showMsg(card, "Ajout en cours…", "info");

        const cartData = await addToCartFormEncoded(variantId, 1);
        showMsg(card, "Ajouté ✅", "success");
        await refreshThemeCart(cartData);

        if (openDrawer) {
          if (scrollToDrawer) window.scrollTo({ top: 0, behavior: "smooth" });
          setTimeout(() => openCartDrawerIfExists(), 120);
        }
      } catch (err) {
        showMsg(card, err?.message || "Erreur lors de l'ajout.", "error");
      } finally {
        setLoading(btn, false);
      }
    });
 
    if (!track) return;

    // ---------- Flèches uniquement — AUCUN wheel hijack ----------
    if (prev) {
      prev.addEventListener("click", () => {
        const perView = getCardsPerView(track);
        goToIndex(track, getCurrentIndex(track) - perView);
        setTimeout(() => updateArrows(track, prev, next), 350);
      });
    }

    if (next) {
      next.addEventListener("click", () => {
        const perView = getCardsPerView(track);
        goToIndex(track, getCurrentIndex(track) + perView);
        setTimeout(() => updateArrows(track, prev, next), 350);
      });
    }

    // Mise à jour des flèches au scroll (natif, sans interférence)
    track.addEventListener("scroll", () => {
      updateArrows(track, prev, next);
    }, { passive: true });

    // Init état des flèches
    updateArrows(track, prev, next);

    // Recalcul au resize
    let resizeTimer = null;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => updateArrows(track, prev, next), 150);
    });

    // ⚠️ AUCUN listener wheel — le scroll vertical de la page reste libre
  }

  // ─────────────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll(ROOT).forEach(bind);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();